import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';
//
import { useAuthContext } from '../hooks';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();

  const {user}=useSelector((state)=>state.user)
  console.log(user ,"user from guest guard");

  const searchParams = useSearchParams();

  const returnTo =  paths.dashboard.root;

  const { authenticated } = useAuthContext();
  const check = useCallback(() => {
    if (user?.accesstoken) {
      router.replace(returnTo);
    } 
  }, [authenticated, returnTo, router , user]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
